/** 统一 Bearer 格式，供显式启用该协议的客户端和服务端请求复用。 */
export function formatBearerAuthorization(token: string | null | undefined): string | undefined {
  const value = token
    ?.trim()
    .replace(/^Bearer(?:\s+|$)/i, '')
    .trim();
  return value ? `Bearer ${value}` : undefined;
}
